import styled from 'styled-components'

const LayoutContainerUi = styled.div`
  margin: 10px 10px 0px 0px;
`

export default LayoutContainerUi
